import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home'
import aboutOur from '@/components/aboutOur/index'
import myTeam from '@/components/myTeam/index'
import newsCenter from  '@/components/newsCenteru/index'
import DaoyuanFamily from '@/components/DaoyuanFamily/index'
import NewInfo from "@/components/newsCenteru/NewInfo";
import error from "@/components/error/error.vue";

import HomeEN from '@/components/Home/HomeEN'
import aboutOurEN from '@/components/aboutOur/indexEN'
import myTeamEN from '@/components/myTeam/indexEN'
import newsCenterEN from  '@/components/newsCenteru/indexEN'
import DaoyuanFamilyEN from '@/components/DaoyuanFamily/indexEN'
Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '/404',
      name: 'error',
      component: error
    },{
      path: '/',
      name: 'Home',
      component: Home
    },{
      path: '/NewInfo/:id',
      name: 'NewInfo',
      component: NewInfo
    },{
      path: '/aboutUs',
      name: 'aboutOur',
      component: aboutOur
    },{
      path: '/ourTeam',
      name: 'ourTeam',
      component: myTeam
    },{
      path: '/newsCenter',
      name: 'newsCenteru',
      component: newsCenter

    },{
      path:'/daoyuanfamily',
      name:'daoyuanfamily',
      component:DaoyuanFamily
    },{
      path: '/en/',
      name: 'EnHome',
      component: HomeEN
    },{
      path: '/en/aboutUs',
      name: 'EnaboutOur',
      component: aboutOurEN
    },{
      path: '/en/ourTeam',
      name: 'EnourTeam',
      component: myTeamEN
    },{
      path: '/en/newsCenter',
      name: 'EnnewsCenteru',
      component: newsCenterEN

    },{
      path:'/en/daoyuanfamily',
      name:'Endaoyuanfamily',
      component:DaoyuanFamilyEN
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js